<template>
  <div>
    <el-row :gutter="20">
      <el-col :md="8" :lg="5">
          <el-input placeholder="环境变量名" v-model="serachKey" clearable size="mini"><el-button slot="append" icon="el-icon-search" @click="nameSearch"></el-button></el-input>
      </el-col>
      <el-col :span="1" class="content-right">
        <el-button size="mini" type="primary" icon="plus" @click="addDialogVisible = true">添加环境变量</el-button>
      </el-col>
    </el-row>
    <el-row>

  </el-row>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="微信小程序" name="wxapp"></el-tab-pane>
      <el-tab-pane label="支付宝" name="alipay"></el-tab-pane>
      <el-tab-pane label="微信" name="wechat"></el-tab-pane>
      <el-tab-pane label="系统" name="system"></el-tab-pane>
      <el-tab-pane label="第三方商户" name="third_merchant"></el-tab-pane>
      <el-tab-pane label="优选" name="youxuan"></el-tab-pane>
      <el-table :data="envList" :height="wheight-160" v-loading="loading">
        <el-table-column prop="name" label="key"></el-table-column>
        <el-table-column prop="value" label="value"></el-table-column>
        <el-table-column prop="description" label="description"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="operating-icons">
              <i class="iconfont icon-edit1" @click="updateDataDialogShow(scope.row)"></i>
              <i class="mark iconfont icon-trash-alt1" @click="deleteData(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </el-tabs>
    <el-dialog
      title="添加环境变量"
      :visible.sync="addDialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form v-model="form" label-width="100px">
        <el-form-item label="变量名">
          <el-input v-model="form.name" placeholder="请输入变量名"></el-input>
        </el-form-item>
        <el-form-item label="变量值">
          <el-input v-model="form.value" placeholder="请输入变量值"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入描述"
            v-model="form.description">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false,form = {}">取 消</el-button>
        <el-button type="primary" @click="addEnv">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改环境变量"
      :visible.sync="updateDialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form v-model="form" label-width="100px">
        <el-form-item label="变量名">
          <el-input v-model="form.name" readonly placeholder="请输入变量名"></el-input>
        </el-form-item>
        <el-form-item label="变量值">
          <el-input v-model="form.value" placeholder="请输入变量值"></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入描述"
            v-model="form.description">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateDialogVisible = false,form = {}">取 消</el-button>
        <el-button type="primary" @click="updateData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { getEnvconfigList, getEnv, createEnv, updateEnv, deleteEnv } from '../../../../api/envconfigs'
  export default {
    data () {
      return {
        activeName: 'wxapp',
        storeList: [],
        envList: [],
        serachKey: '',
        total_count: 0,
        loading: false,
        addDialogVisible: false,
        updateDialogVisible: false,

        form: {
          type: 'wxapp'
        },
        options: [{
          value: 'wxapp',
          label: '微信小程序'
        }, {
          value: 'wechat',
          label: '微信'
        }, {
          value: 'alipay',
          label: '支付宝'
        }, {
          value: 'system',
          label: '系统'
        }, {
          value: 'third_merchant',
          label: '第三方商户'
        }, {
          value: 'youxuan',
          label: '优选'
        }
        ],
        params: {
          page: 1,
          pageSize: 15,
          type: 'wxapp'
        }
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      // 切换tab
      handleClick(tab, event) {
        this.activeName = tab.name
        this.form.type = tab.name
        this.params.type = tab.name
        this.params.page = 1
        this.serachKey = null
        this.params.name = null
        this.getList()
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getList()
      },
      nameSearch () {
        this.params.name = this.serachKey
        this.params.page = 1
        this.getList()
      },
      getList () {
        this.loading = true
        getEnvconfigList(this.params).then(response => {
          if(response.data.data.list) {
            this.envList = response.data.data.list
            this.total_count = Number(response.data.data.total_count)
          }
          this.loading = false
        }).catch( error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表数据出错'
          })
        })
      },
      addEnv () {
        createEnv(this.form).then(response => {
          this.addDialogVisible = false
          this.getList()
          this.$message({
            type: 'success',
            message: '添加成功'
          })
          this.form = {}
        })
      },
      deleteData (index, row) {
        this.$confirm('此操作将删除该环境变量, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteEnv(row.env_id).then(response => {
            this.envList.splice(index, 1)
            this.$message({
              type: 'success',
              message: '删除成功'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      updateDataDialogShow (row) {
        this.updateDialogVisible = true
        this.form = row
      },
      updateData () {
        updateEnv(this.form).then(response=>{
          this.updateDialogVisible = false
          this.getList()
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.form = {}
        })
      },
      handleClose(done) {
        this.$confirm('确认取消？')
          .then(_ => {
            this.form = {}
            done();
          })
          .catch(_ => {});
      }
    },
    mounted () {
       this.getList()
    }
  }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// list.vue?1a96fa38